import { FC } from "react"
import { useTranslation } from "react-i18next"
import { useFeatureFlag } from "Hooks/useFeatureFlag"
import Button from "Components/UI/Button"
import { loadImage } from "Utils/MultidomailUtils"
import { Container, TopContainer, BottomContainer } from "./styles"

interface IFollowInfoCardProps {
  onClose: () => void
}

const FollowInfoCard: FC<IFollowInfoCardProps> = ({ onClose }) => {
  const { t } = useTranslation(['sharedModals', 'common'])
  const followFolderInfoCardUrlFlag = useFeatureFlag('follow-folder-info-card-url')
  const followFolderInfoCardUrl = (followFolderInfoCardUrlFlag.enabled && typeof followFolderInfoCardUrlFlag.value === 'string')
    ? followFolderInfoCardUrlFlag.value
    : 'https://maleta.doengenheiro.com.br/'

  const redirect = () => {
    window.open(followFolderInfoCardUrl)
  }

  return (
    <Container>
      <TopContainer>
        <img src={loadImage('info-follow-card-img.svg')} alt="FollowInfoCard" />
      </TopContainer>
      <BottomContainer>
        <div><span className="tagNew">{t('sharedModals:followInfo.badge')}</span></div>
        <div className="titleContainer">
          <span className="title">
            {t('sharedModals:followInfo.title')}
          </span>
          <span className="description">
            {t('sharedModals:followInfo.description')}
          </span>
        </div>
        <div className="buttonContainer">
          <Button type="text" onClick={redirect}>{t('common:learnMore')}</Button>
          <Button type="text" onClick={onClose}>{t('common:close')}</Button>
        </div>
      </BottomContainer>
    </Container>
  )
}

export default FollowInfoCard
